var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"page"}},[_c('h3',[_vm._v(_vm._s(_vm._f("artTitleSelect")(_vm.data.title)))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }